import { createFileRoute } from '@tanstack/react-router'
import { ChangePasswordPage } from '../../features/auth/change-password-page'

export const Route = createFileRoute('/_app/change-password')({
  staticData: { crumb: 'changePassword' },
  component: ChangePasswordPage,
})
